import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCart, updateCartQty } from '../../utils/cartStore';
import { formatVnd } from '../../constants/shopOrderStatus';
import { resolveImageSrc } from '../../utils/productGallery';
import { PLACEHOLDER_300 } from '../../utils/imagePlaceholder';
import './CheckoutPage.css';

const CartPage = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState(getCart());

  useEffect(() => {
    setItems(getCart());
  }, []);

  const total = useMemo(
    () => items.reduce((sum, item) => sum + Number(item.price) * Number(item.quantity), 0),
    [items]
  );

  return (
    <div className="checkout-page">
      <div className="checkout-card">
        <button type="button" className="checkout-back" onClick={() => navigate('/shop/products')}>
          Quay lại cửa hàng
        </button>
        <h1>Giỏ hàng</h1>
        {!items.length ? (
          <p className="checkout-empty">Giỏ hàng trống.</p>
        ) : (
          <>
            {items.map((item) => (
              <div key={item.productId} className="checkout-item">
                <img
                  src={item.imageUrl ? resolveImageSrc(item.imageUrl) : PLACEHOLDER_300}
                  alt=""
                  onError={(e) => { e.target.src = PLACEHOLDER_300; }}
                />
                <div>
                  <div className="checkout-item-name">{item.name}</div>
                  <div className="checkout-item-price">₫{formatVnd(item.price)}</div>
                  {item.stockQty != null ? (
                    <div className="checkout-item-stock">Tồn kho: {item.stockQty}</div>
                  ) : null}
                </div>
                <input
                  className="cart-qty"
                  type="number"
                  min="1"
                  max="99"
                  value={item.quantity}
                  onChange={(e) => setItems(updateCartQty(item.productId, e.target.value))}
                />
                <button type="button" className="cart-remove" onClick={() => setItems(updateCartQty(item.productId, 0))}>Xóa</button>
              </div>
            ))}
            <div className="checkout-total">Tổng: ₫{formatVnd(total)}</div>
            <button type="button" className="checkout-submit" onClick={() => navigate('/shop/checkout')}>
              Đặt hàng
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CartPage;
